import Vue from 'vue'
import Vuex from 'vuex'

Vue.use(Vuex)

export default new Vuex.Store({
  state: {
    // 浏览器ctrl缩放的比例
    browserSize: 1,
    browserWidth: null,
    showLoading: false,
    // 显示页面的权限控制
    showPageAuthor: 0,
    // aliplayer查看视频时VID的存放
    apliplayerID: null,
    // 存放左侧菜单参数
    Mune: {
      openWhereUl: [''],
      openWhereLi: 'functionIndex'
    },
    // 控制资源显示Modal
    sourceModal: false,
    sourceType: true,
    // 面包屑数据
    breadList: [{
      name: 'home',
      path: '/admin/home'
    }, {
      name: 'contenttwo',
      path: '/admin/home/contenttwo'
    }],
    tableHeight: document.documentElement.clientHeight - 280
  },
  mutations: {
    showLoadMask (state, res) {
      state.showLoading = res
    },
    controlbrowserSize (state, project) {
      state.browserSize = project
    },
    controlbrowserWidth (state, project) {
      state.browserWidth = project
    },
    leftWhereSetect (state, project) {
      state.Mune = project
    },
    controlshowPageAuthor (state, project) {
      state.showPageAuthor = project
    },
    controlapliplayerID (state, project) {
      state.apliplayerID = project
    },
    controlSourceType (state, project) {
      state.sourceType = project
    },
    controlSourceModal (state, project) {
      state.sourceModal = project
    },
    changeTableHeight (state, height) {
      state.tableHeight = height
    }
  },
  actions: {
    showLoad (context, res) {
      context.commit('showLoadMask', res)
    },
    browserSize (context, res) {
      context.commit('controlbrowserSize', res)
    },
    browserWidth (context, res) {
      context.commit('controlbrowserWidth', res)
    },
    showPageAuthor (context, res) {
      context.commit('controlshowPageAuthor', res)
    },
    apliplayerID (context, res) {
      context.commit('controlapliplayerID', res)
    },
    sourceType (context, res) {
      context.commit('controlSourceType', res)
    },
    sourceModal (context, res) {
      context.commit('controlSourceModal', res)
    }
  },
  modules: {
  }
})
